import { useCallback, useState, useEffect } from 'react';
import { useLocation, useNavigate, NavLink } from 'react-router-dom';
import { useReactiveVar } from '@apollo/client';
import styled, { css } from 'styled-components';
import { IoArrowBackSharp } from 'react-icons/io5';

import theme from '@styles/theme';
import LOGO_HOSP from '@assets/icons/logo_hosp.svg';
import LOGO_AD from '@assets/icons/logo_ad.svg';
import { getCookie } from '@utils/cookie';
import { headerTabMenu } from '@lib/data';
import { tabMenuType } from '@utils/types';
import { userLogout } from '@modules/authentication';
import { userVar } from '@store/index';
import { AGREEMENT_DATA } from '@lib/DUMMY';

import { FlexBox, Image } from '@components/styled/StyledComponents';
import AgreementModal from '@components/share/Modal/AgreementModal';
import WelcomeModal from '@components/share/Modal/WelcomeModal';
import StyledButton from '@components/styled/StyledButton';

const Header = () => {
    const { agreement } = useReactiveVar(userVar);
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const [welcomeModal, setWelcomeModal] = useState(false);
    const [passwordModal, setPasswordModal] = useState(false);
    const isLoggedIn = getCookie('HMT') ?? false;

    //   // 비밀번호 변경 기간 체크 (3개월)
    //   useEffect(() => {
    //     const lastUpdate = new Date(pwUpdateDate as string);
    //     const diffMilliseconds = Date.now() - lastUpdate.getTime();
    //     const diffDate = Math.floor(
    //       Math.abs(diffMilliseconds / (1000 * 60 * 60 * 24))
    //     );

    //     // 비밀번호 초기화를 했거나 변경 6개월이 넘었을 경우, 로그인 직후에만 모달 오픈
    //     if (passwordInit || diffDate > 90) {
    //       setPasswordModal(true);
    //     }
    //   }, [pwUpdateDate, passwordInit]);

    const handleGoBack = () => {
        if (!window.confirm('페이지 이동 시 입력된 정보가 모두 사라집니다.'))
            return;
        navigate(-1);
    };

    // FullFormPage 사용 시, 기존 헤더 숨김
    const goBackHeader = pathname.includes('/edit');

    if (goBackHeader)
        return (
            <Wrapper>
                <Contents>
                    <FlexBox $justifyContent="space-between">
                        <GoBackBtn onClick={handleGoBack}>
                            <IoArrowBackSharp size={24} />
                            <Text>뒤로가기</Text>
                        </GoBackBtn>
                    </FlexBox>
                </Contents>
            </Wrapper>
        );

    return (
        <Wrapper>
            {!isLoggedIn && (
                <FlexBox
                    onClick={() => window.location.reload()}
                    $justifyContent="center"
                    $alignItems="center"
                    $height="80px"
                >
                    <Logo>
                        <Image
                            src={
                                pathname.includes('advertiser')
                                    ? LOGO_AD
                                    : LOGO_HOSP
                            }
                            alt="헬로미디어 로고"
                        />
                    </Logo>
                </FlexBox>
            )}
            {isLoggedIn && (
                <Contents>
                    <Nav>
                        <Logo
                            onClick={() => (window.location.href = '/main')}
                            // onClick={() => navigate('/dashboard')}
                            $margin="0 20px 0 0"
                        >
                            <Image src={LOGO_HOSP} alt="헬로미디어 로고" />
                        </Logo>
                        <MenuList>
                            {headerTabMenu.map(
                                (list: tabMenuType, index: number) => (
                                    <MenuText
                                        key={`${index}-tab-${list.dataText}`}
                                        to={`${list.pathname}`}
                                    >
                                        {list.dataText}
                                    </MenuText>
                                )
                            )}
                        </MenuList>
                    </Nav>
                    <Button
                        $color={theme.colors.pointBlue}
                        onClick={userLogout}
                    >
                        로그아웃
                    </Button>
                </Contents>
            )}
            {isLoggedIn && !agreement && (
                <AgreementModal
                    isOpen={!agreement}
                    setWelcomeModal={setWelcomeModal}
                    data={AGREEMENT_DATA}
                />
            )}
            {welcomeModal && (
                <WelcomeModal
                    isOpen={welcomeModal}
                    setIsOpen={setWelcomeModal}
                    data={
                        '<p>[개인정보 수집·이용 동의] 2025년 4월 7일</p><p>[서비스 이용 약관 동의] 2025년 4월 7일</p>'
                    }
                />
            )}
        </Wrapper>
    );
};

export default Header;

const Wrapper = styled.header`
    position: sticky;
    top: 0;
    width: 100%;
    height: 80px;
    border-bottom: ${theme.colors.ultraLightGrayBorder} 1px solid;
    background-color: ${theme.colors.whiteColor};
    z-index: 5;
`;

const Contents = styled.nav`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    width: 1280px;
    height: 80px;
`;

const Nav = styled.div`
    display: flex;
    align-items: center;
`;

const Logo = styled.h1<{ $margin?: string }>`
    margin: ${({ $margin }) => ($margin ? $margin : 0)};
    width: 135px;
    height: 20px;
    cursor: pointer;
`;
const MenuList = styled.nav`
    display: flex;
    align-items: center;
    gap: 20px;
    font-size: 14px;
`;
const MenuText = styled(NavLink)`
    font-family: PretendardMedium, sans-serif;
`;
const Button = styled.button<{ $color: string }>`
    padding: 0 10px;
    height: 32px;
    color: ${({ $color }) => $color};
    border: ${({ $color }) => `${$color} 1px solid`};
    background-color: ${theme.colors.whiteColor};
    border-radius: 4px;
    font-size: 14px;
    transition: 0.25s;

    &:hover {
        background-color: ${theme.colors.lightGrayHoverColor};
    }
`;
const GoBackBtn = styled.button`
    display: flex;
    align-items: center;
`;

const Text = styled.span`
    margin-left: 12px;
    font-size: 14px;
`;
